export default class InventoryUnit {
  constructor(id, state = 'available') {
    this.id = id;
    this.state = state;
  }

  static fromAttributes({ id, state }) {
    return new InventoryUnit(id, state);
  }
}
